const ErrorsEnum = {
    // NO ISSUES
    NO_ERROR: 'NO_ERROR',

    // SUBSCRIBER ISSUES
    NO_CELLULAR_SUBSCRIBER: 'NO_CELLULAR_SUBSCRIBER',
    BUSINESS_SUBSCRIBER: 'BUSINESS_SUBSCRIBER',
    KOSHER_SUBSCRIBER: 'KOSHER_SUBSCRIBER',
    SUBSCRIBER_ABROAD: 'SUBSCRIBER_ABROAD',

    // BROWSING ISSUES
    BLOCK_BROWSE: 'BLOCK_BROWSE',

    // SERVICE ISSUES
    NO_REGISTERED: 'NO_REGISTERED',
    DATA_ONLY: 'DATA_ONLY',
    CELLULAR_DATA_OFF_WITHOUT_APN: 'CELLULAR_DATA_OFF_WITHOUT_APN',
    CELLULAR_DATA_OFF_WITH_APN: 'CELLULAR_DATA_OFF_WITH_APN',
    NO_DATA_AND_ROAMING: 'NO_DATA_AND_ROAMING',
    SWITCH_RESTRICTED: 'SWITCH_RESTRICTED',
    NO_DEFAULT_APN: 'NO_DEFAULT_APN',
    //CALLS
    HAS_FOLLOW_ME: 'HAS_FOLLOW_ME',
    HAS_BLOCK_INCOMING_CALLS: 'HAS_BLOCK_INCOMING_CALLS',
    HAS_BLOCK_OUTGOING_CALLS: 'HAS_BLOCK_OUTGOING_CALLS',
    NO_ERROR_INCOMING_CALLS: 'NO_ERROR_INCOMING_CALLS',
    NO_ERROR_OUTGOING_CALLS: 'NO_ERROR_OUTGOING_CALLS',

    // PACKAGE ISSUES
    NO_CELLULAR_PACKAGE: 'NO_CELLULAR_PACKAGE',
    RESTRICTED_BROWSE: 'RESTRICTED_BROWSE',
    INCOMPATIBLE_PACKAGE: 'INCOMPATIBLE_PACKAGE',

    // FINANCIAL ISSUES
    FINANCIAL_DEBT_ERROR: 'FINANCIAL_DEBT_ERROR',
    FINANCIAL_PAYMENT_UPDATE_ERROR: 'FINANCIAL_PAYMENT_UPDATE_ERROR',
    FINANCIAL_PAYMENT_UPDATE_AND_DEBT_ERROR: 'FINANCIAL_PAYMENT_UPDATE_AND_DEBT_ERROR',
    FINANCIAL_PAYMENT_METHOD_UPDATE_ERROR: 'FINANCIAL_PAYMENT_METHOD_UPDATE_ERROR', // = FINANCIAL_PAYMENT_UPDATE_AND_DEBT_ERROR

    // SUSPENDED SUBSCRIBER ISSUES
    SUSPENDED_SUBSCRIBER_LOST_OR_STOLEN: 'SUSPENDED_SUBSCRIBER_LOST_OR_STOLEN',
    SUSPENDED_SUBSCRIBER: 'SUSPENDED_SUBSCRIBER',

    //SECURITY
    DEFENSE_POLICY_BLOCKED: 'DEFENSE_POLICY_BLOCKED',

    // REPRESENTATIVE ISSUES
    CONTINUE_TO_REPRESENTATIVE: 'CONTINUE_TO_REPRESENTATIVE',
    NO_ERROR_MABAL: 'NO_ERROR_MABAL',

    // GENERAL ERRORS
    GENERAL_ERROR: 'GENERAL_ERROR',
    ACTION_FAILED: 'ACTION_FAILED',
    DEVICE_ACTION_FAILED: 'DEVICE_ACTION_FAILED',
    UNRESOLVED_ISSUE: 'UNRESOLVED_ISSUE',
    NO_ERROR_DATA: 'NO_ERROR_DATA',

    // CALLBACK ISSUES
    CALLBACK_ALREADY_SCHEDULED: 'CALLBACK_ALREADY_SCHEDULED',
};


export default ErrorsEnum;

